import { createSelector } from "reselect";

import getScanDatasetsForProjectByFirebaseId from "./get_scan_datasets_for_project_by_firebase_id";
import ScanDataset from "../../../models/domain/scan_dataset";

/**
 * The date of each of the project's floors' most recent pointcloud scan, keyed by the floor's firebase
 * id. This is the per-area counterpart to [[getMostRecentScanDatasetForFloor]]: the deviation IFC export
 * can span several areas at once, and each one carries its own most recent scan.
 *
 * Floors with no pointcloud scan are absent from the result, since a photo-only capture has no
 * deviations to export.
 */
const getMostRecentScanDatesByFloorId = createSelector([
  getScanDatasetsForProjectByFirebaseId
], (scanDatasetsByFirebaseId): { [floorId: string]: Date } => {
  return Object.values(scanDatasetsByFirebaseId || {}).reduce<{ [floorId: string]: Date }>((datesByFloorId, scanDataset) => {
    if (!scanDataset?.firebaseFloorId || !scanDataset.scanDate || !ScanDataset.hasPointcloud(scanDataset)) {
      return datesByFloorId;
    }
    const mostRecent = datesByFloorId[scanDataset.firebaseFloorId];
    if (!mostRecent || scanDataset.scanDate.valueOf() > mostRecent.valueOf()) {
      datesByFloorId[scanDataset.firebaseFloorId] = scanDataset.scanDate;
    }
    return datesByFloorId;
  }, {});
});

export default getMostRecentScanDatesByFloorId;
